(function () {

    'use strict';

    angular.module('Services').factory('BreakBulkShipmentsTable', BreakBulkShipmentsTable);

    function BreakBulkShipmentsTable(Shipments,
                                     Carrier,
                                     TableLiteFactory,
                                     $filter,
                                     toastr,
                                     $q,
                                     $uibModal,
                                     ConfirmationModalFactory,
                                     TableHelpers) {
        return function (defaultFilters) {
            const presetFilters = angular.extend(angular.copy(defaultFilters), {breakBulk: true});
            let viewConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.archive.MESSAGE',
                code: 'messages.warning.archive.CODE',
            });
            const bookingStatuses = {
                inprogress: 'Processing',
                processed: 'Completed',
                pending: 'Awaiting Booking'
            };
            let ShipmentsTableData = {
                tableName: 'BreakBulkShipmentsTable',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    extraction: [{
                        type: 'csv',
                        advanced: function () {
                            $uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title',
                                ariaDescribedBy: 'modal-body',
                                templateUrl: '/templates/directives/intellectual-table/advance-extract/extract-shipment.html',
                                controller: 'AdvanceExtractionModalController',
                                controllerAs: 'vm',
                                windowClass: 'full-height-modal',
                                size: 'md',
                                appendTo: $('body'),
                                resolve: {
                                    tableHeaders: function () {
                                        return ShipmentsTableData.headers.map(header => {
                                            return {
                                                label: header.label,
                                                viewName: header.viewName,
                                                filterName: header.filterName,
                                                filter: (function () {
                                                    var headerFilter = angular.copy(header.filter);
                                                    if (header.filter) {
                                                        return {
                                                            type: headerFilter.type,
                                                            class: headerFilter.class,
                                                            placeholder: headerFilter.placeholder,
                                                            useArray: true
                                                        }
                                                    }
                                                    return null;
                                                })()
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }],
                },
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'CREATE NEW CLAIM',
                        onClick: function () {
                            const selectedData = ShipmentsTableData.data.filter(shipment => shipment.isSelected);
                            if (selectedData.length < 1) {
                                toastr.warning('Select one shipment only', 'Multiple Shipment Selected');
                                return;
                            }

                            const modalInstance = $uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title',
                                ariaDescribedBy: 'modal-body',
                                templateUrl: '/templates/pages/transit-warranty/modal/transit-warranty-claim-details-modal.html',
                                controller: 'TransitWarrantyClaimDetails',
                                controllerAs: 'vm',
                                size: 'md',
                                appendTo: $('body'),
                                resolve: {
                                    shipment: () => selectedData[0],
                                    claimDetails: () => null
                                }
                            });

                            modalInstance.result.then(() => {
                                tableActions.sendRequest({});
                            });
                        }
                    }, {
                        class: 'btn-success',
                        label: 'Archive',
                        onClick: function () {
                            const shipmentId = [];
                            const selectedData = ShipmentsTableData.data.filter(shipment => shipment.isSelected);
                            if (selectedData.length < 1) {
                                toastr.warning('Select one shipment only', 'Multiple Shipment Selected');
                                return;
                            }

                            for (let i = 0; i < selectedData.length; i++) {
                                shipmentId.push(selectedData[i].id)
                            }

                            viewConfirmation.getInstance().result.then(function (cond) {
                                if (cond) {
                                    reasonToCancelModal(shipmentId)
                                    
                                }
                            });
                        }
                    },{
                        class: 'btn-success',
                        label: 'Update Tracking Status',
                        onClick: function () {
                            const shipmentId = [];
                            const selectedData = ShipmentsTableData.data.filter(shipment => shipment.isSelected);
                            if (selectedData.length < 1) {
                                toastr.warning('Select one shipment only', 'Multiple Shipment Selected');
                                return;
                            }

                            for (let i = 0; i < selectedData.length; i++) {
                                shipmentId.push(selectedData[i].id)
                            }

                            changeTrackingStatusModal(shipmentId)
                        }
                    }]
                },
                headers: [{
                    label: 'SELECT',
                    class: 'text-center',
                    width: '10',
                    filter: {
                        type: 'checkbox'
                    }
                }, {
                    label: 'Created Date',
                    viewName: 'createdDate',
                    filterName: 'createdDate',
                    width: '135px',
                    filter: {
                        type: 'datePicker',
                        url: '',
                        class: 'filter-date',
                        toModel: defaultFilters.createdDate ? new Date(defaultFilters.createdDate[0]) : '',
                        fromModel: defaultFilters.createdDate ? new Date(defaultFilters.createdDate[1]) : '',
                        useArray: true,
                        onSubmit: function (header) {

                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                            //sendRequest();
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CONSIGNMENT NO.',
                    viewName: 'consignmentId',
                    filterName: 'bbConsignmentId',
                    width: '135px',
                    filter: {
                        type: 'text',
                        class: 'filter-consignment-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'RECEIPT NO.',
                    viewName: 'receiptNo',
                    filterName: 'paymentDetails.receiptNumber',
                    width: '135px',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'PICKUP REFERENCE NO.',
                    viewName: 'dhlBookingReferenceNo',
                    filterName: 'carrierOrderId',
                    width: '135px',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'BBA REFERENCE NO.',
                    viewName: 'bbaReferenceNo',
                    filterName: 'bbaReferenceNumber',
                    width: '135px',
                    filter: {
                        type: 'text',
                        class: 'filter-bba-reference-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Company',
                    viewName: 'companyName',
                    filterName: 'companyName',
                    width: '135px',
                    filter: {
                        type: 'text',
                        class: 'filter-company',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: ' Office/Location',
                    viewName: 'locationName',
                    filterName: 'locationName',
                    width: '135px',
                    filter: {
                        type: 'text',
                        class: 'filter-company',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Payment Type',
                    viewName: 'paymentType',
                    filterName: 'paymentDetails.paymentType',
                    width: '135px',
                }, {
                    label: 'Account',
                    viewName: 'accountEmail',
                    filterName: 'userEmail',
                    width: '135px',
                    filter: {
                        type: 'text',
                        class: 'filter-account',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'BOOKING STATUS',
                    viewName: 'bookingStatus',
                    filterName: 'bookingStatus',
                    width: '135px',
                    filter: {
                        type: 'select2',
                        placeholder: 'Search',
                        class: 'table-input',
                        items: [{
                            value: 'pending',
                            viewName: 'Awaiting Booking'
                        }, {
                            value: 'inprogress',
                            viewName: 'Processing'
                        }, {
                            value: 'processed',
                            viewName: 'Completed'
                        }],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model;
                            tableActions.sendRequest(filter);
                        },
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'TRACKING NO.',
                    viewName: 'trackingNumber',
                    filterName: 'trackingNumber',
                    width: '135px',
                    filter: {
                        type: 'text',
                        class: 'filter-tracking-number',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CUSTOMER REF. NO.',
                    viewName: 'customerReferences',
                    filterName: 'customerReferences',
                    width: '135px',
                    filter: {
                        type: 'text',
                        class: 'filter-customer-ref',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Third Party System Reference No.',
                    viewName: 'wmsReference',
                    filterName: 'wmsReference',
                    width: '200px',
                    filter: {
                        type: 'text',
                        class: 'filter-consigment-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Linked Job',
                    viewName: 'jobId',
                    filterName: 'job.id',
                    filter: {
                        type: 'text',
                        class: 'filter-customer-ref',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CARRIER PROFILE',
                    viewName: 'carrierProfileName',
                    filterName: 'carrierProfileId',
                    sortName: 'carrierProfile.id',
                    width: '135px',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        model: defaultFilters ? defaultFilters.carrierProfile : '',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.carrierProfilesCompact((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, {size: 30, name: model});
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },
                    {
                        label: 'SERVICE PROFILE',
                        viewName: 'serviceProfileName',//to fix
                        filterName: 'serviceProfileId',//to fix
                        width: '135px',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            viewName: 'displayName',
                            filterBy: 'id',
                            items: [], //List of items shown in dropdown
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            },
                            refresh: function (model) {
                                const defer = $q.defer();
                                let filterItems = this.items;
                                Carrier.serviceProfilesCompact((data) => {
                                    filterItems.length = 0;
                                    angular.forEach(data.content, (profile) => {
                                        filterItems.push(profile);
                                    });
                                    filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                    defer.resolve();
                                }, (error) => {
                                    defer.reject();
                                }, {
                                    size: 30,
                                    name: model,
                                    carrierProfileId: tableActions.activeFilters.carrierProfileId
                                });
                                return defer.promise;
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    }, {
                        label: 'Source Address',
                        viewName: 'sourceAdd'
                    }, {
                        label: 'Destination Address',
                        viewName: 'destinationAdd'
                    }, {
                        label: 'First Mile',
                        viewName: 'firstMile',
                        width: '200px',
                        filterName: 'breakBulkDetails.firstMile.consignmentId',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        }
                    }, {
                        label: 'Last Mile',
                        viewName: 'lastMile',
                        width: '200px',
                        filterName: 'breakBulkDetails.lastMile.consignmentId',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        }
                    }, {
                        label: 'AMOUNT EX TAX',
                        viewName: 'amount'
                    }],
                data: [],
                extractTable: function (form) {

                },
                resetFilters: () => {
                    tableActions.resetFilters();
                },
                onInit: function () {
                    tableActions.sendRequest({});
                }
            };
            const tableActions = new TableLiteFactory(ShipmentsTableData,
                {
                    serviceCallback: Shipments.getBreakBulkShipments,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'createdDate,desc'
                    }, presetFilters)
                }
            );

            function buildTableData(data) {
                /*** START - Building of Data ***/

                if (!data)
                    return ShipmentsTableData;
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.createdDate = $filter('bbaDate')(item.createdDate); // Format Date MM/dd/YYYY
                    item.consignmentId = item.consignmentId || 'N/A';
                    item.wmsReference = item.wmsReference || 'N/A';
                    item.companyName = angular.getObjVal(item, 'company.name') || 'N/A';
                    item.locationName = angular.getObjVal(item, 'office.name') || 'N/A';
                    item.accountEmail = angular.getObjVal(item, 'user.email') || 'N/A';
                    item.carrierProfileName = angular.getObjVal(item, 'serviceProfile.carrierProfile.name') || 'N/A';
                    item.serviceProfileName = angular.getObjVal(item, 'serviceProfile.name') || 'N/A';
                    item.trackingNumber = item.trackingNumber ? item.trackingNumber : 'N/A';
                    item.jobId = angular.getObjVal(item, 'job.jobId') || 'N/A';
                    item.bbaReferenceNo = angular.getObjVal(item, 'bbaReferenceNumber') || 'N/A';
                    item.paymentType = angular.getObjVal(item, 'paymentDetails') ? 'Credit Card' : 'On Account';
                    item.dhlBookingReferenceNo = angular.getObjVal(item, 'carrierOrderId') || 'N/A';
                    if (item.serviceDetails) {
                        item.carrierName = {
                            type: 'logotype',
                            imgSrc: item.serviceDetails.logo
                        };
                        item.serviceName = item.serviceDetails.serviceName;
                    }
                    item.amount = Shipments.getShipmentCostFormatted(item).amountFormatted;
                    item.bookingStatus = bookingStatuses[item.bookingStatus]; // Define Bo oking Status
                    item.customerReferences =
                        item.customerReferences && item.customerReferences.length ?
                            item.customerReferences.join(', ') :
                            'N/A'; // Join Multiple Customer Refs in One
                    if (item.sourceAddress) {
                        item.sourceAdd = {
                            type: 'multiLine',
                            list: [
                                item.sourceAddress.addressLine1 || undefined,
                                item.sourceAddress.addressLine2 || undefined,
                            ]
                        };
                        const loc = item.sourceAddress.location;
                        if (loc) {
                            item.sourceAdd.list = item.sourceAdd.list.concat([
                                loc.name + (loc.state ? ', ' + loc.state.code : '') + ' ' + loc.code,
                                angular.getObjVal(loc, 'country.name')
                            ]);
                        }
                    } else {
                        item.sourceAdd = 'N/A';
                    }
                    if (item.destinationAddress) {
                        item.destinationAdd = {
                            type: 'multiLine',
                            list: [
                                item.destinationAddress.addressLine1 || undefined,
                                item.destinationAddress.addressLine2 || undefined,
                            ]
                        };
                        const loc = item.destinationAddress.location;
                        if (loc) {
                            item.destinationAdd.list = item.destinationAdd.list.concat([
                                loc.name + (loc.state ? ', ' + loc.state.code : '') + ' ' + loc.code,
                                angular.getObjVal(loc, 'country.name')
                            ]);
                        }
                    } else {
                        item.destinationAdd = 'N/A';
                    }

                    item.firstMile = {
                        type: 'multiLine',
                        list: TableHelpers.buildBreakBulkDetails(angular.getObjVal(item, 'breakBulkDetails.firstMile')),
                    }
                    item.lastMile = {
                        type: 'multiLine',
                        list: TableHelpers.buildBreakBulkDetails(angular.getObjVal(item, 'breakBulkDetails.lastMile')),
                    };

                    item.receiptNo = angular.getObjVal(item, 'paymentDetails.receiptNumber') || 'N/A';
                    item.href = '/shipments/view/' + item.id;
                    ShipmentsTableData.data.push(item);
                });
            }

             function changeTrackingStatusModal(selected){
                $uibModal.open({
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/shipments/modal/change-trackingStatus-modal.html',
                    controller: 'ChangeTrackingStatusModalController',
                    controllerAs: 'vm',
                    keyboard: false,
                    // backdrop: 'static',
                    // windowClass: 'loading-indicator',
                    size: 'md',
                    resolve: {
                        shipmentIds: () => {
                            return selected;
                        }
                    },
                    // appendTo: $('body')
                }).result.then((result) => {
                    if (result) {
                        tableActions.sendRequest({});
                    }
                });;
            }

             function reasonToCancelModal(selected){
                $uibModal.open({
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/shipments/modal/reason-cancellation-modal.html',
                    controller: 'ReasonOfCancellationModalController',
                    controllerAs: 'vm',
                    keyboard: false,
                    // backdrop: 'static',
                    // windowClass: 'loading-indicator',
                    size: 'md',
                    resolve: {
                        shipmentIds: () => {
                            return selected;
                        }
                    },
                    // appendTo: $('body')
                }).result.then((result) => {
                    if (result) {
                        tableActions.sendRequest({});
                    }
                });;
            }

            this.tableData = ShipmentsTableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/BreakBulkShipmentsTable.js